import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step997411Meta extends BaseModel {
  isSkipped?: boolean;

  constructor(model: Partial<Step997411Meta> = {}) {
    super();

    this.isSkipped = model.isSkipped ?? false;
  }
}
